import { Observable } from 'rxjs';
import { AdminCreateResidenceRequest, Residence, ResidenceSubType, ResidenceVerificationStatus, ReviewResidenceRequest } from '../residence.model';
import { Address } from '../../user/user.model';

export abstract class ResidenceService {
    abstract getPendingResidences(): Observable<Residence[]>;

    abstract getAllResidences(status?: ResidenceVerificationStatus): Observable<Residence[]>;

    abstract getCitizenResidences(userId: string): Observable<Residence[]>;

    abstract reviewResidence(id: string, dto: ReviewResidenceRequest): Observable<Residence>;

    abstract createResidence(dto: AdminCreateResidenceRequest): Observable<Residence>;

    abstract setAsPrimary(residenceId: string): Observable<Residence>;

    abstract reviewRenewal(id: string, dto: ReviewResidenceRequest): Observable<Residence>;

    abstract updateResidenceName(id: string, name: string): Observable<Residence>;

    abstract updateResidenceAddress(id: string, address: Address): Observable<Residence>;

    abstract updateResidenceSubType(id: string, subType: ResidenceSubType): Observable<Residence>;
}
